var App = {};
var MyModules = {};
var Manager = {};